module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "8",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": _vm.viewReport
    }
  }, [_vm._v("View HTML Report")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": _vm.viewPayoutsReport
    }
  }, [_vm._v("View Payouts Report")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.selectedCampaignID === null
    },
    on: {
      "click": function($event) {
        return _vm.getCampaignDataToView(_vm.selectedCampaignID)
      }
    }
  }, [_vm._v("View Campaign Brief")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.exportPDF(_vm.selectedCampaignID, _vm.campaignData.name, false)
      }
    }
  }, [_vm._v("\n              Download PDF\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-pdf-box")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel(_vm.selectedCampaignID, _vm.campaignData.name, false)
      }
    }
  }, [_vm._v("\n              Download Excel\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-excel")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.quickReload()
      }
    }
  }, [_vm._v("\n              Reload Page\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.getCampaignReport(_vm.selectedCampaignID, true)
      }
    }
  }, [_vm._v("\n              Refresh Data\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.changeSettings(_vm.campaignData)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders-h"
  }), _vm._v(" Campaign Settings\n            ")])], 1)])])], 1), _vm._v(" "), _c('div', [(_vm.campaignData) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "460px"
    },
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-2 pb-0"
  }, [_vm._v("\n              Campaign Name: " + _vm._s(_vm.campaignData ? _vm.campaignData.name : 'N/A') + "\n              "), (_vm.markupCOGSAmount) ? _c('v-chip', {
    attrs: {
      "color": "warning",
      "small": "",
      "text-color": "white"
    }
  }, [_vm._v("\n                Markup COGS\n              ")]) : _vm._e(), _vm._v(" "), (_vm.campaignData.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 font-weight-light"
  }, [_vm._v(" Current Status: " + _vm._s(_vm.currentCampaignStatusDisplay))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n              Client Name: " + _vm._s(_vm.client ? _vm.client.name : 'N/A') + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0 pt-2",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              IO Number: " + _vm._s(_vm.campaignData ? (_vm.campaignData.ioNumbers || 'N/A') : 'N/A') + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.budget)) + "\n            ")]), _vm._v(" "), (_vm.campaignData.revenueCalculation === 'engagement') ? _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Calculation Method: Engagement\n            ")]) : _vm._e(), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Campaign Period: " + _vm._s(_vm.minLiveDate) + " - " + _vm._s(_vm.maxLiveDate) + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-3",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Number of Reviewers: " + _vm._s(_vm.numberOfReviewers) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-container', {
    staticClass: "pl-0 pr-0",
    staticStyle: {
      "padding-top": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md6": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "outreach-kpi-row"
  }, [_c('div', {
    staticClass: "display-text"
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-0 headline mb-3 font-weight-medium",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Outreach KPI")]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)) + " / " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.outreach)))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.summary.outreach_percentage) + "%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "odometer-gauge"
  }, [_c('div', {
    staticClass: "odometer-arc"
  }, [_c('svg', {
    staticClass: "odometer-arc-svg",
    attrs: {
      "viewBox": "0 0 170 90",
      "preserveAspectRatio": "none"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "outreachArcGradient",
      "x1": "0%",
      "y1": "0%",
      "x2": "100%",
      "y2": "0%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#ef5350"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#66bb6a"
    }
  })], 1)], 1), _vm._v(" "), _c('path', {
    staticClass: "odometer-arc-track-path",
    attrs: {
      "d": "M 10 85 A 75 75 0 0 1 160 85"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "odometer-arc-progress-path",
    style: ({
      strokeDasharray: ("" + _vm.outreachArcLength),
      strokeDashoffset: ("" + _vm.outreachArcOffset),
      stroke: 'url(#outreachArcGradient)'
    }),
    attrs: {
      "d": "M 10 85 A 75 75 0 0 1 160 85"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "odometer-needle",
    style: ({
      transform: ("translateX(-50%) rotate(" + _vm.outreachNeedleRotation + "deg)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "odometer-arc-center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "odometer-meta"
  }, [_c('span', {
    staticClass: "odometer-percent"
  }, [_vm._v(_vm._s(_vm.outreachRatioPercent) + "%")])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "contents-kpi-row"
  }, [_c('div', {
    staticClass: "display-text"
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-0 headline mb-3 font-weight-medium",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Contents KPI")]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm.summary.contents) + " / " + _vm._s(_vm.campaignData.min_content))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.summary.contents_percentage) + "%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-gauge"
  }, [_c('div', {
    staticClass: "contents-progress-head"
  }, [_c('span', {
    staticClass: "contents-progress-percent"
  }, [_vm._v(_vm._s(_vm.contentsRatioPercent) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-track"
  }, [_c('div', {
    staticClass: "contents-progress-fill",
    style: ({
      width: (_vm.contentsProgressFillPercent + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-scale"
  }, [_c('span', [_vm._v("0%")]), _vm._v(" "), _c('span', [_vm._v("50%")]), _vm._v(" "), _c('span', [_vm._v("100%")])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "135px"
    },
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Outreach + Impressions")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.outreachImpressionsTotal)))])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("COGS KPI")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalCounts.amount)) + " / $" + _vm._s(_vm._f("thousandSeprator")(_vm.budget)))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.cogsPercentage) + "%")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.campaignData) ? _c('campaign-summary', {
    attrs: {
      "campaign": _vm.campaignData,
      "isInternalView": true,
      "respData": _vm.respData
    },
    on: {
      "loading-status": _vm.handleLoadingStatus,
      "saved": function($event) {
        return _vm.quickReload()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedCampaignID) ? _c('div', [(_vm.respData && _vm.selectedCampaignID) ? _c('report-for-summary', {
    attrs: {
      "respData": _vm.respData,
      "campaignID": _vm.selectedCampaignID
    },
    on: {
      "loading-status": _vm.handleLoadingStatus
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "10",
      "md": "10",
      "lg": "10"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "rounded": "",
      "color": "secondary",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.addPost()
      }
    }
  }, [_vm._v("Add Content")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "disabled": _vm.disableSaveArrange,
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveLineUp()
      }
    }
  }, [_vm._v("Save Posts Arrangement")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    attrs: {
      "rounded": "",
      "color": "warning",
      "disabled": !_vm.selectedPosts || _vm.selectedPosts.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openReportGroupModal()
      }
    }
  }, [_vm._v("Add to Group (" + _vm._s(_vm.selectedPosts.length) + ")")])], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    attrs: {
      "xs": "12",
      "sm": "2",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-btn-toggle', {
    staticClass: "float-right",
    attrs: {
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "fill-height": ""
    }
  }, [(_vm.posts.length) ? _c('v-row', {
    staticClass: "justify-right"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.postTypes,
      "item-text": "title",
      "item-value": "title",
      "label": "Content Type",
      "filled": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.postType),
      callback: function($$v) {
        _vm.postType = $$v
      },
      expression: "postType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Live Date",
            "readonly": "",
            "clearable": "",
            "filled": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.getFiltered()
            }
          },
          model: {
            value: (_vm.searchMonth),
            callback: function($$v) {
              _vm.searchMonth = $$v
            },
            expression: "searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3538331557),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.searchMonth),
      callback: function($$v) {
        _vm.searchMonth = $$v
      },
      expression: "searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-5",
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('div', {
    staticClass: "no-gutters",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "margin-bottom": "10px",
      "padding": "10px"
    }
  }, [_c('draggable', {
    staticClass: "row clearfix",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "update": function($event) {
        return _vm.handleDragDropUpdate(_vm.filteredPosts)
      }
    },
    model: {
      value: (_vm.filteredPosts),
      callback: function($$v) {
        _vm.filteredPosts = $$v
      },
      expression: "filteredPosts"
    }
  }, _vm._l((_vm.filteredPosts), function(post) {
    return _c('div', {
      key: post.id,
      class: {
        'pa-2 col-sm-12 col-md-4 col-lg-3 col': !post.reportGroup && !_vm.isTwitterReport(post),
        'pa-2 col-sm-12 col-md-6 col-lg-4 col twitter-grid-column': !post.reportGroup && _vm.isTwitterReport(post),
        'row mb-2': post.reportGroup
      },
      style: (post.reportGroup ? 'width:100%' : '')
    }, [(post.reportGroup) ? _c('v-col', {
      staticClass: "pa-3 pr-0 mt-3",
      attrs: {
        "cols": "auto",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-expansion-panels', {
      staticClass: "post-group-panel",
      attrs: {
        "multiple": "",
        "dark": "",
        "accordion": "",
        "focusable": ""
      },
      model: {
        value: (post.panel),
        callback: function($$v) {
          _vm.$set(post, "panel", $$v)
        },
        expression: "post.panel"
      }
    }, [_c('v-expansion-panel', {
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', [_vm._v(_vm._s(post.name) + " (" + _vm._s(post.reports.length) + ")")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.reports) ? _c('v-row', {
      staticClass: "no-gutters",
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "10px"
      }
    }, [_c('draggable', {
      staticClass: "row no-gutters flex-wrap flex-row fill-height",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "update": function($event) {
          return _vm.handleDragDropUpdate(post.reports)
        }
      },
      model: {
        value: (post.reports),
        callback: function($$v) {
          _vm.$set(post, "reports", $$v)
        },
        expression: "post.reports"
      }
    }, _vm._l((post.reports), function(post) {
      return _c('v-col', {
        key: post.id,
        staticClass: "pa-2",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": _vm.isTwitterReport(post) ? 6 : 4,
          "lg": _vm.isTwitterReport(post) ? 4 : 3
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [(post.success && !_vm.isLinkedInReport(post) && !_vm.isTwitterReport(post)) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.post_details.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.profileHandle || post.profile_handle || post.post_details.owner.username)),
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.post_details.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('instagram-post-embed', {
              attrs: {
                "url": _vm.getReportPostUrl(post)
              }
            })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isTwitterReport(post) ? 'Replies' : 'Comments'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.scrapComments(post.post_details.link, post.id)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Extract Comments\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      View on IG\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-instagram")])], 1)], 1)], 1) : (post.isOthers || _vm.isLinkedInReport(post) || _vm.isTwitterReport(post)) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover,
                'linkedin-campaign-post': _vm.isLinkedInReport(post),
                'twitter-campaign-post': _vm.isTwitterReport(post)
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": _vm.isTwitterReport(post) ? 420 : 300,
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold",
              class: {
                'twitter-embed-card-text': _vm.isTwitterReport(post)
              }
            }, [(_vm.isLinkedInReport(post) && _vm.getLinkedInEmbedUrl(post)) ? _c('iframe', {
              staticClass: "linkedin-post-embed",
              attrs: {
                "src": _vm.getLinkedInEmbedUrl(post),
                "title": ("LinkedIn post by " + (post.owner.username)),
                "width": "100%",
                "height": "300",
                "frameborder": "0",
                "allowfullscreen": ""
              }
            }) : (_vm.isTwitterReport(post) && _vm.getTwitterEmbedUrl(post)) ? _c('div', {
              staticClass: "twitter-embed-shell"
            }, [_c('iframe', {
              staticClass: "twitter-post-embed",
              attrs: {
                "src": _vm.getTwitterEmbedUrl(post),
                "title": ("X post by " + (post.owner.username)),
                "frameborder": "0",
                "allowfullscreen": ""
              }
            })]) : _vm._e(), _vm._v(" "), (post.media_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
              attrs: {
                "className": _vm.getMedia(post).className,
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
              staticClass: "elevation-0",
              attrs: {
                "width": "100%",
                "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
              }
            }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
              attrs: {
                "width": "100%",
                "controls": ""
              }
            }, [_c('source', {
              attrs: {
                "src": post.media_url,
                "type": "video/mp4"
              }
            }), _vm._v("\n                                        Your browser does not support HTML5 video.\n                                      ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
              attrs: {
                "url": post.media_url
              }
            }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
              staticClass: "media-iframe",
              attrs: {
                "width": "100%",
                "height": "100%",
                "src": post.media_url,
                "scrolling": "no",
                "seamless": "",
                "allowFullScreen": ""
              }
            }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isTwitterReport(post) ? 'Replies' : 'Comments'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      " + _vm._s(_vm.isLinkedInReport(post) ? 'View on LinkedIn' : (_vm.isTwitterReport(post) ? 'View on X' : 'View')) + "\n                                      "), (_vm.isLinkedInReport(post)) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-linkedin")]) : (_vm.isTwitterReport(post)) ? _c('img', {
              staticClass: "ml-2",
              staticStyle: {
                "filter": "invert(1)"
              },
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "18px",
                "alt": "",
                "aria-hidden": "true"
              }
            }) : _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1) : (post.isStory) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (post.media_url) ? _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
              attrs: {
                "className": _vm.getMedia(post).className,
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
              staticClass: "elevation-0",
              attrs: {
                "width": "100%",
                "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
              }
            }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
              attrs: {
                "width": "100%",
                "controls": ""
              }
            }, [_c('source', {
              attrs: {
                "src": post.media_url,
                "type": "video/mp4"
              }
            }), _vm._v("\n                                    Your browser does not support HTML5 video.\n                                  ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
              attrs: {
                "url": post.media_url
              }
            }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
              staticClass: "media-iframe",
              attrs: {
                "width": "100%",
                "height": "100%",
                "src": post.media_url,
                "scrolling": "no",
                "seamless": "",
                "allowFullScreen": ""
              }
            }) : _vm._e()], 1) : _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('div', [_c('v-alert', {
              attrs: {
                "width": "100%"
              }
            }, [_vm._v("\n                                      Media type unsupported!\n                                    ")])], 1)]), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Story Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Accounts Reached")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                    Update Insights\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (post.media_url) ? _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View Story Media\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1)], 1) : (post.isTikTok) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.tikTokPost) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": post.tikTokPost,
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Total Play Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Favourites (Bookmarks)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Watched Full Video")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watchedFullVideo))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.scrapComments(post.post_details.link, post.id)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Extract Comments\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": "",
                "color": "blue-grey",
                "disabled": !post.comments || post.comments.length === 0
              },
              on: {
                "click": function($event) {
                  return _vm.openCommentsDialog(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      View on TikTok "), _c('img', {
              attrs: {
                "src": "/static/img/tik-tok-white.png",
                "width": "18px"
              }
            })])], 1)], 1) : (post.isFacebook) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": 'https://www.facebook.com/' + post.owner.username,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(post)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.media_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": _vm.getFbPost(post.media_url),
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Facebook\n                                  ")])], 1)], 1) : (post.isXHS) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": 'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(_vm.item)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.embed_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on XHS\n                                  ")])], 1)], 1) : (post.isLemon) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": ""
              }
            }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(_vm.item)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.embed_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Lemon8\n                                  ")])], 1)], 1) : (post.isYoutube) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": 'https://www.youtube.com/' + post.owner.username,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              staticClass: "campaign-post-type-chip",
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_c('span', {
              staticClass: "campaign-post-type-title",
              attrs: {
                "title": post.type
              }
            }, [_vm._v(_vm._s(post.type))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.youtubePost) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": post.youtubePost,
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.impressions != null) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.unique_viewers != null) ? _c('tr', [_c('td', [_vm._v("Unique Viewers")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.unique_viewers))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches != null) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.outreach))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Youtube  "), _c('i', {
              staticClass: "fab fa-youtube"
            })])], 1)], 1) : (post.isMultipleContents) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Story Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exits")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.exits))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Back")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_back))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Forward")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_forward))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                    Update Insights\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
              staticClass: "justify-center"
            }, [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1)], 1)], 1) : _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-icon', {
              attrs: {
                "large": "",
                "left": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('span', {
              staticClass: "caption font-weight-light"
            }, [_vm._v("Anonymous User")])], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "title font-weight-bold"
            }, [_vm._v("\n                                  Post might be deleted or private. Click\n                                  "), _c('a', {
              attrs: {
                "target": "_blank",
                "href": ("https://instagram.com/p/" + (post.post_details.shortcode))
              }
            }, [_vm._v("Here")]), _vm._v(" for more details.\n                                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Instagram\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-instagram")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _c('div', [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(post.success && !_vm.isLinkedInReport(post) && !_vm.isTwitterReport(post)) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.post_details.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.profileHandle || post.profile_handle || post.post_details.owner.username)),
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.post_details.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('instagram-post-embed', {
            attrs: {
              "url": _vm.getReportPostUrl(post)
            }
          })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.scrapComments(post.post_details.link, post.id)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Extract Comments\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": "",
              "color": "blue-grey",
              "disabled": !post.comments || post.comments.length === 0
            },
            on: {
              "click": function($event) {
                return _vm.openCommentsDialog(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          View on IG\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1)], 1) : (post.isOthers || _vm.isLinkedInReport(post) || _vm.isTwitterReport(post)) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover,
              'linkedin-campaign-post': _vm.isLinkedInReport(post),
              'twitter-campaign-post': _vm.isTwitterReport(post)
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": _vm.isTwitterReport(post) ? 420 : 300,
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold",
            class: {
              'twitter-embed-card-text': _vm.isTwitterReport(post)
            }
          }, [(_vm.isLinkedInReport(post) && _vm.getLinkedInEmbedUrl(post)) ? _c('iframe', {
            staticClass: "linkedin-post-embed",
            attrs: {
              "src": _vm.getLinkedInEmbedUrl(post),
              "title": ("LinkedIn post by " + (post.owner.username)),
              "width": "100%",
              "height": "300",
              "frameborder": "0",
              "allowfullscreen": ""
            }
          }) : (_vm.isTwitterReport(post) && _vm.getTwitterEmbedUrl(post)) ? _c('div', {
            staticClass: "twitter-embed-shell"
          }, [_c('iframe', {
            staticClass: "twitter-post-embed",
            attrs: {
              "src": _vm.getTwitterEmbedUrl(post),
              "title": ("X post by " + (post.owner.username)),
              "frameborder": "0",
              "allowfullscreen": ""
            }
          })]) : _vm._e(), _vm._v(" "), (post.media_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
            attrs: {
              "className": _vm.getMedia(post).className,
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
            staticClass: "elevation-0",
            attrs: {
              "width": "100%",
              "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
            }
          }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
            attrs: {
              "width": "100%",
              "controls": ""
            }
          }, [_c('source', {
            attrs: {
              "src": post.media_url,
              "type": "video/mp4"
            }
          }), _vm._v("\n                            Your browser does not support HTML5 video.\n                          ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
            attrs: {
              "url": post.media_url
            }
          }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
            staticClass: "media-iframe",
            attrs: {
              "width": "100%",
              "height": "100%",
              "src": post.media_url,
              "scrolling": "no",
              "seamless": "",
              "allowFullScreen": ""
            }
          }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          " + _vm._s(_vm.isLinkedInReport(post) ? 'View on LinkedIn' : (_vm.isTwitterReport(post) ? 'View on X' : 'View')) + "\n                          "), (_vm.isLinkedInReport(post)) ? _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-linkedin")]) : (_vm.isTwitterReport(post)) ? _c('img', {
            staticClass: "ml-2",
            staticStyle: {
              "filter": "invert(1)"
            },
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "18px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1) : (post.isStory) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1)], 1)], 1), _vm._v(" "), (post.media_url) ? _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
            attrs: {
              "className": _vm.getMedia(post).className,
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
            staticClass: "elevation-0",
            attrs: {
              "width": "100%",
              "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
            }
          }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
            attrs: {
              "width": "100%",
              "controls": ""
            }
          }, [_c('source', {
            attrs: {
              "src": post.media_url,
              "type": "video/mp4"
            }
          }), _vm._v("\n                        Your browser does not support HTML5 video.\n                      ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
            attrs: {
              "url": post.media_url
            }
          }) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
            staticClass: "media-iframe",
            attrs: {
              "width": "100%",
              "height": "100%",
              "src": post.media_url,
              "scrolling": "no",
              "seamless": "",
              "allowFullScreen": ""
            }
          }) : _vm._e()], 1) : _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('div', [_c('v-alert', {
            attrs: {
              "width": "100%"
            }
          }, [_vm._v("\n                          Media type unsupported!\n                        ")])], 1)]), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Story Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Accounts Reached")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                        Update Insights\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (post.media_url) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View Story Media\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1)], 1) : (post.isTikTok) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.tikTokPost) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": post.tikTokPost,
              "allow": "fullscreen"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Total Play Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Favourites (Bookmarks)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Watched Full Video")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watchedFullVideo))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.scrapComments(post.post_details.link, post.id)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Extract Comments\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": "",
              "color": "blue-grey",
              "disabled": !post.comments || post.comments.length === 0
            },
            on: {
              "click": function($event) {
                return _vm.openCommentsDialog(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          View on TikTok "), _c('img', {
            attrs: {
              "src": "/static/img/tik-tok-white.png",
              "width": "18px"
            }
          })])], 1)], 1) : (post.isFacebook) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": 'https://www.facebook.com/' + post.owner.username,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.media_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": _vm.getFbPost(post.media_url),
              "allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
              "allowfullscreen": "true",
              "scrolling": "no"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Facebook\n                      ")])], 1)], 1) : (post.isXHS) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.embed_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on XHS \n                      ")])], 1)], 1) : (post.isLemon) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": ""
            }
          }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.embed_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Lemon8 \n                      ")])], 1)], 1) : (post.isYoutube) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": 'https://www.youtube.com/' + post.owner.username,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            staticClass: "campaign-post-type-chip",
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_c('span', {
            staticClass: "campaign-post-type-title",
            attrs: {
              "title": post.type
            }
          }, [_vm._v(_vm._s(post.type))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.youtubePost) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": post.youtubePost,
              "allow": "fullscreen"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.impressions != null) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.unique_viewers != null) ? _c('tr', [_c('td', [_vm._v("Unique Viewers")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.unique_viewers))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches != null) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.outreach))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Youtube "), _c('i', {
            staticClass: "fab fa-youtube"
          })])], 1)], 1) : (post.isMultipleContents) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Story Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exits")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.exits))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Back")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_back))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Forward")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_forward))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                        Update Insights\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
            staticClass: "justify-center"
          }, [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1)], 1)], 1) : _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-icon', {
            attrs: {
              "large": "",
              "left": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('span', {
            staticClass: "caption font-weight-light"
          }, [_vm._v("Anonymous User")])], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "title font-weight-bold"
          }, [_vm._v("\n                      Post might be deleted or private. Click\n                      "), _c('a', {
            attrs: {
              "target": "_blank",
              "href": ("https://instagram.com/p/" + (post.post_details.shortcode))
            }
          }, [_vm._v("Here")]), _vm._v(" for more details.\n                    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Instagram\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.display === 1) ? _c('div', {
    staticClass: "no-gutters",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "disabled": _vm.disableSaveEdit
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    staticStyle: {
      "max-width": "50px",
      "float": "right"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-1 report__table",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "show-expand": "",
      "expanded": _vm.expanded,
      "search": _vm.searchFilter,
      "single-select": false,
      "custom-sort": _vm.customSort
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      },
      "toggle-select-all": _vm.selectAllPosts,
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([{
      key: "item.instagram",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "210px"
          }
        }, [(item.reportGroup) ? _c('label', [_vm._v(_vm._s(item.instagram) + " (" + _vm._s(item.reports.length) + ")\n                ")]) : _vm._e(), _vm._v(" "), (!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !_vm.isLinkedInReport(item) && !_vm.isTwitterReport(item) && !item.isXHS && !item.isLemon) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": _vm.getAccountProfileUrl(item)
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isTikTok) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": _vm.getAccountProfileUrl(item)
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isYoutube) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://youtube.com/' + item.instagram
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isFacebook) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://facebook.com/' + item.instagram
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isLinkedInReport(item)) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.linkedin.com/in/' + item.instagram
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isTwitterReport(item)) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://x.com/' + item.instagram
          }
        }, [_c('img', {
          staticClass: "mr-1",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "14px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isXHS) ? _c('a', {
          attrs: {
            "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.fullName))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isLemon) ? _c('a', [_vm._v("@" + _vm._s(item.fullName))]) : _vm._e(), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
          attrs: {
            "bottom": "",
            "origin": "center center",
            "transition": "scale-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticStyle: {
                  "min-width": "0",
                  "max-width": "20px",
                  "padding": "0",
                  "margin-top": "-3px"
                },
                attrs: {
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                attrs: {
                  "bottom": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;

                    return [_c('v-icon', _vm._g({
                      attrs: {
                        "color": "warning",
                        "small": ""
                      }
                    }, on), [_vm._v("mdi-chevron-down-circle")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
          return _c('v-list-item', {
            key: i,
            attrs: {
              "link": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePlatform(obj, i)
              }
            }
          }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
        }), 1)], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.media_url",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "100px"
          }
        }, [(item.media_url === '-' || item.media_url === '') ? _c('p', [_vm._v("-")]) : _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                    View Media\n                  ")])], 1)])]) : _vm._e()]
      }
    }, {
      key: "item.typeName",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.typeName))])])]) : _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(item.typeName))])])])]
      }
    }, {
      key: "item.live_date",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.liveDateEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'liveDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.live_date))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "solo": ""
          },
          model: {
            value: (item.live_date),
            callback: function($$v) {
              _vm.$set(item, "live_date", $$v)
            },
            expression: "item.live_date"
          }
        }, _vm.on))], 1)]) : _vm._e()]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
      }
    }, {
      key: "item.due_date",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.dueDateEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'dueDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.due_date))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "solo": ""
          },
          model: {
            value: (item.due_date),
            callback: function($$v) {
              _vm.$set(item, "due_date", $$v)
            },
            expression: "item.due_date"
          }
        }, _vm.on))], 1)]) : _vm._e()]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.amountLocked) ? _c('div', [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("-")])])]) : _c('div', [_c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))])])])]) : _vm._e()]
      }
    }, {
      key: "item.ims_status",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.imsStatusEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'imsStatus')
            }
          }
        }, [(!item.noPayout) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.getIMSStatus(item.ims_status, item.payment_status)) + "\n                ")]) : _vm._e()]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.imsStatusOptions,
            "item-value": "status",
            "item-text": "display",
            "label": "IMS Status"
          },
          model: {
            value: (item.ims_status),
            callback: function($$v) {
              _vm.$set(item, "ims_status", $$v)
            },
            expression: "item.ims_status"
          }
        })], 1)])]) : _vm._e()]
      }
    }, {
      key: "item.payment_status",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.payment_status)))])])]) : _vm._e()]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [(item.reportGroup) ? _c('td', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteReportGroup(item.id, item.name)
            }
          }
        }, [_vm._v("\n                Remove Group\n                "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1)], 1) : _c('td', [(item.type === 'Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details.link,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View on IG\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-instagram")])], 1)], 1) : (item.type === 'Story') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View Story Media\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (item.type === 'TikTok') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View TikTok Media\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (_vm.isLinkedInReport(item) || item.type === 'LinkedIn Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details ? item.post_details.link : '',
            "target": '_blank'
          }
        }, [_vm._v("\n                  View on LinkedIn\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-linkedin")])], 1)], 1) : (_vm.isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": _vm.getReportPostUrl(item),
            "target": "_blank"
          }
        }, [_vm._v("\n                  View on X\n                  "), _c('img', {
          staticClass: "ml-2",
          staticStyle: {
            "filter": "invert(1)"
          },
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "18px",
            "alt": "",
            "aria-hidden": "true"
          }
        })])], 1) : (item.type === 'Others') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1)], 1) : (item.type === 'facebook') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View Facebook Post\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-facebook")])], 1) : _vm._e()], 1) : _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.isYoutube || item.platform === 'instagram') ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details ? item.post_details.link : '',
            "target": '_blank'
          }
        }, [(item.isYoutube) ? _c('span', [_vm._v("\n                    View on Youtube "), _c('i', {
          staticClass: "fab fa-youtube"
        })]) : _vm._e(), _vm._v(" "), (item.platform === 'instagram') ? _c('span', [_vm._v("\n                    View on Instagram\n                    "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-instagram")])], 1) : _vm._e()]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.data-table-expand",
      fn: function(ref) {
        var item = ref.item;
        var expand = ref.expand;
        var isExpanded = ref.isExpanded;

        return [(item.reportGroup) ? _c('span', [(isExpanded) ? _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(false)
            }
          }
        }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(true)
            }
          }
        }, [_vm._v("mdi-chevron-down")])], 1) : _c('v-icon', [_vm._v("mdi-file-chart")])]
      }
    }, {
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": "",
            "md6": ""
          }
        }, [(!item.reportGroup) ? _c('v-checkbox', {
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedPosts),
            callback: function($$v) {
              _vm.selectedPosts = $$v
            },
            expression: "selectedPosts"
          }
        }) : _c('v-icon', [_vm._v("mdi-file-multiple")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": "",
            "md6": ""
          }
        }, [(!item.reportGroup) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                      mdi-reload\n                    ")])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.filteredReports) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          directives: [{
            name: "sortable-data-table",
            rawName: "v-sortable-data-table"
          }],
          staticClass: "elevation-1",
          attrs: {
            "headers": headers,
            "items": item.filteredReports,
            "show-select": "",
            "single-select": false,
            "custom-sort": _vm.customSort,
            "search": _vm.searchFilter
          },
          on: {
            "sorted": _vm.handleDataTableDragDrop
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-select",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_c('v-layout', {
                attrs: {
                  "wrap": ""
                }
              }, [_c('v-flex', {
                attrs: {
                  "xs6": "",
                  "md6": ""
                }
              }, [_c('v-checkbox', {
                attrs: {
                  "label": "",
                  "value": item,
                  "color": "grey darken-2"
                },
                model: {
                  value: (_vm.selectedPosts),
                  callback: function($$v) {
                    _vm.selectedPosts = $$v
                  },
                  expression: "selectedPosts"
                }
              })], 1), _vm._v(" "), _c('v-flex', {
                attrs: {
                  "xs6": "",
                  "md6": ""
                }
              }, [_c('v-btn', {
                staticClass: "btn-reload",
                attrs: {
                  "text": "",
                  "x-small": "",
                  "color": "warning"
                },
                on: {
                  "click": function($event) {
                    return _vm.refreshReportInf(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "small": ""
                }
              }, [_vm._v("\n                            mdi-reload\n                          ")])], 1)], 1)], 1)], 1)]
            }
          }, {
            key: "item.instagram",
            fn: function(ref) {
              var item = ref.item;

              return [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "100px"
                }
              }, [(item.reportGroup) ? _c('label', [_vm._v(_vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !_vm.isLinkedInReport(item) && !_vm.isTwitterReport(item) && !item.isLemon) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": _vm.getAccountProfileUrl(item)
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isYoutube) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://youtube.com/' + item.instagram
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isTikTok) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": _vm.getAccountProfileUrl(item)
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isFacebook) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://facebook.com/' + item.instagram
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isLinkedInReport(item)) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://www.linkedin.com/in/' + item.instagram
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": "#0A66C2",
                  "small": ""
                }
              }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isTwitterReport(item)) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://x.com/' + item.instagram
                }
              }, [_c('img', {
                staticClass: "mr-1",
                attrs: {
                  "src": "/static/img/x-logo.svg",
                  "width": "14px",
                  "alt": "",
                  "aria-hidden": "true"
                }
              }), _vm._v(" @" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isLemon) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": ""
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
                attrs: {
                  "bottom": "",
                  "origin": "center center",
                  "transition": "scale-transition"
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;
                    var attrs = ref.attrs;

                    return [_c('v-btn', _vm._g(_vm._b({
                      staticStyle: {
                        "min-width": "0",
                        "max-width": "20px",
                        "padding": "0",
                        "margin-top": "-3px"
                      },
                      attrs: {
                        "dark": "",
                        "text": ""
                      }
                    }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                      attrs: {
                        "bottom": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on;

                          return [_c('v-icon', _vm._g({
                            attrs: {
                              "color": "warning",
                              "small": ""
                            }
                          }, on), [_vm._v("mdi-chevron-down-circle")])]
                        }
                      }], null, true)
                    }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
                return _c('v-list-item', {
                  key: i,
                  attrs: {
                    "link": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changePlatform(obj, i)
                    }
                  }
                }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
                  attrs: {
                    "src": "/static/img/xhs-black.png",
                    "width": "20px"
                  }
                }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
                  attrs: {
                    "color": "#000000",
                    "small": ""
                  }
                }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
                  attrs: {
                    "src": "/static/img/tiktok-32.png",
                    "width": "20px"
                  }
                }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
                  attrs: {
                    "color": "#000000",
                    "small": ""
                  }
                }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
              }), 1)], 1) : _vm._e()], 1)])]
            }
          }, {
            key: "item.media_url",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "100px"
                }
              }, [(item.media_url === '-' || item.media_url === '') ? _c('p', [_vm._v("-")]) : _c('v-btn', {
                attrs: {
                  "small": "",
                  "text": "",
                  "color": "secondary",
                  "elevation": "0",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                          View Media\n                        ")])], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.type",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "120px"
                }
              }, [_vm._v(_vm._s(item.typeName))])])]) : _vm._e()]
            }
          }, {
            key: "item.live_date",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.liveDateEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'liveDate')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(item.live_date))])]) : _c('div', [_c('v-text-field', _vm._g({
                staticClass: "mt-3",
                staticStyle: {
                  "width": "290px",
                  "float": "left"
                },
                attrs: {
                  "solo": ""
                },
                model: {
                  value: (item.live_date),
                  callback: function($$v) {
                    _vm.$set(item, "live_date", $$v)
                  },
                  expression: "item.live_date"
                }
              }, _vm.on))], 1)]) : _vm._e()]
            }
          }, {
            key: "item.outreach",
            fn: function(ref) {
              var item = ref.item;

              return [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
            }
          }, {
            key: "item.due_date",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.dueDateEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'dueDate')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(item.due_date))])]) : _c('div', [_c('v-text-field', _vm._g({
                staticClass: "mt-3",
                staticStyle: {
                  "width": "290px",
                  "float": "left"
                },
                attrs: {
                  "solo": ""
                },
                model: {
                  value: (item.due_date),
                  callback: function($$v) {
                    _vm.$set(item, "due_date", $$v)
                  },
                  expression: "item.due_date"
                }
              }, _vm.on))], 1)]) : _vm._e()]
            }
          }, {
            key: "item.amount",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.amountLocked) ? _c('div', [_c('div', {
                staticClass: "item-edit"
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v("-")])])]) : _c('div', [(item.amountEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'amount')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left"
              }, [_c('v-text-field', {
                staticClass: "mt-3",
                staticStyle: {
                  "width": "150px"
                },
                attrs: {
                  "solo": "",
                  "type": "number"
                },
                model: {
                  value: (item.amount),
                  callback: function($$v) {
                    _vm.$set(item, "amount", $$v)
                  },
                  expression: "item.amount"
                }
              })], 1)])])]) : _vm._e()]
            }
          }, {
            key: "item.ims_status",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.imsStatusEdit === false && !item.noPayout) ? _c('div', {
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'imsStatus')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(_vm.getIMSStatus(item.ims_status, item.payment_status)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_c('v-select', {
                attrs: {
                  "items": _vm.imsStatusOptions,
                  "item-value": "status",
                  "item-text": "display",
                  "label": "IMS Status"
                },
                model: {
                  value: (item.ims_status),
                  callback: function($$v) {
                    _vm.$set(item, "ims_status", $$v)
                  },
                  expression: "item.ims_status"
                }
              })], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.payment_status",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.paymentStatusEdit === false) ? _c('div', {
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'paymentStatus')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.payment_status)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_c('v-select', {
                attrs: {
                  "items": _vm.paymentStatusOptions,
                  "item-value": "status",
                  "item-text": "display",
                  "label": "Payment Status"
                },
                model: {
                  value: (item.payment_status),
                  callback: function($$v) {
                    _vm.$set(item, "payment_status", $$v)
                  },
                  expression: "item.payment_status"
                }
              })], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [(item.reportGroup) ? _c('td', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.deleteReportGroup(item.id, item.name)
                  }
                }
              }, [_vm._v("\n                      Remove Group\n                      "), _c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("delete")])], 1)], 1) : _c('td', [(item.type === 'Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details.link,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View on IG\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-instagram")])], 1)], 1) : (item.type === 'Story') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View Story Media\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (item.type === 'TikTok') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View TikTok Media\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (_vm.isLinkedInReport(item) || item.type === 'LinkedIn Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details ? item.post_details.link : '',
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View on LinkedIn\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-linkedin")])], 1)], 1) : (_vm.isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": _vm.getReportPostUrl(item),
                  "target": "_blank"
                }
              }, [_vm._v("\n                        View on X\n                        "), _c('img', {
                staticClass: "ml-2",
                staticStyle: {
                  "filter": "invert(1)"
                },
                attrs: {
                  "src": "/static/img/x-logo.svg",
                  "width": "18px",
                  "alt": "",
                  "aria-hidden": "true"
                }
              })])], 1) : (item.type === 'facebook') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View Facebook Post\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-facebook")])], 1) : _vm._e()], 1) : _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details ? item.post_details.link : '',
                  "target": '_blank'
                }
              }, [(item.isYoutube) ? _c('span', [_vm._v("\n                        View on Youtube "), _c('i', {
                staticClass: "fab fa-youtube"
              })]) : _c('span', [_vm._v("\n                        View on Instagram\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-instagram")])], 1)])], 1)])]
            }
          }], null, true),
          model: {
            value: (_vm.selectedPosts),
            callback: function($$v) {
              _vm.selectedPosts = $$v
            },
            expression: "selectedPosts"
          }
        })], 1) : _vm._e()]
      }
    }], null, true),
    model: {
      value: (_vm.selectedPosts),
      callback: function($$v) {
        _vm.selectedPosts = $$v
      },
      expression: "selectedPosts"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalCounts.contents)))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])])], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCampaignID) ? _c('div', [_c('report-payout-lists', {
    attrs: {
      "campaignID": _vm.selectedCampaignID
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "selectedPostIds": _vm.selectedPostIds,
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataView,
      "campaignPayouts": _vm.campaignPayouts
    },
    on: {
      "done": function($event) {
        return _vm.quickReload()
      },
      "addedReport": _vm.addReportManually
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewCampaignModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewCampaignModalDialog),
      callback: function($$v) {
        _vm.viewCampaignModalDialog = $$v
      },
      expression: "viewCampaignModalDialog"
    }
  }), _vm._v(" "), _c('update-insights-modal', {
    attrs: {
      "value": _vm.postInsightdialog,
      "post": _vm.updatePostInsightsData,
      "campaign": _vm.campaignData,
      "imagesToView": _vm.campaignPayout
    },
    on: {
      "done": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.postInsightdialog),
      callback: function($$v) {
        _vm.postInsightdialog = $$v
      },
      expression: "postInsightdialog"
    }
  }), _vm._v(" "), _c('report-group-modal', {
    attrs: {
      "selectedPosts": _vm.selectedPosts,
      "campaignID": _vm.selectedCampaignID
    },
    on: {
      "saved": _vm.savedReportGroup
    },
    model: {
      value: (_vm.reportGroupDialog),
      callback: function($$v) {
        _vm.reportGroupDialog = $$v
      },
      expression: "reportGroupDialog"
    }
  }), _vm._v(" "), _c('edit-report-handle-modal', {
    attrs: {
      "report": _vm.editHandleReport
    },
    on: {
      "saved": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.editReportHandleDialog),
      callback: function($$v) {
        _vm.editReportHandleDialog = $$v
      },
      expression: "editReportHandleDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Table Settings",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('campaign-settings', {
    attrs: {
      "campaign": _vm.campaignData
    },
    on: {
      "saved": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.campaignSettingsDialog),
      callback: function($$v) {
        _vm.campaignSettingsDialog = $$v
      },
      expression: "campaignSettingsDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isScrapLoading),
      callback: function($$v) {
        _vm.isScrapLoading = $$v
      },
      expression: "isScrapLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4 text-center"
  }, [_c('v-progress-linear', {
    staticClass: "mb-3",
    attrs: {
      "indeterminate": "",
      "color": "white",
      "height": "6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-1",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.scrapingStatusMessage))])], 1)], 1)], 1), _vm._v(" "), _c('view-post-comments-modal', {
    attrs: {
      "value": _vm.viewCommentsDialog,
      "comments": _vm.selectedPostComments
    },
    on: {
      "close": function($event) {
        _vm.viewCommentsDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78d73f4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignReportInternal.vue
// module id = 2209
// module chunks = 0